<!-- static content data from lang: patient_list -->
<template>
    <div class="container">
        <div class="my-3" v-loading="loading" >
            <b-card class="patient-listing">
                <div class="row">
                    <template v-if="errored"> {{lang.label.error}}</template>
                    <template v-else>
                        <template v-if="data.length > 0">
                            <div class="col-md-6 col-lg-4" v-for="(patient, index) in data" :key="index">            
                                <b-card class="shadow-none" body-class="p-3">
                                    <div class="row">
                                        <div class="col-6 col-lg-5">
                                            <span class="mb-2 d-block">{{lang.label.name}}:</span> 
                                        </div>
                                        <div class="col-6 col-lg-7">
                                            <span class="mb-2 d-block">{{(patient.name!=''? patient.name :lang.label.nodata)}}</span>

                                        </div>
                                        <div class="col-6 col-lg-5">
                                            <span class="mb-2 d-block">{{lang.label.phoneNumber}}:</span>

                                        </div>
                                        <div class="col-6 col-lg-7">
                                            <span class="mb-2 d-block">{{(patient.mobile!=''? patient.mobile :lang.label.nodata)}}</span>

                                        </div>
                                        <div class="col-6 col-lg-5" >
                                            <span class="mb-2 d-block">{{lang.label.emailId}}:</span>

                                        </div>
                                        <div class="col-6 col-lg-7">
                                            <span class="mb-2 d-block">{{(patient.email!=''? patient.email :lang.label.nodata)}}</span>

                                        </div>
                                        <div class="col-6 col-lg-5">
                                            <span class="mb-2 d-block">{{lang.label.dob}}:</span>

                                        </div>
                                        <div class="col-6 col-lg-7">
                                            <span class="mb-2 d-block">{{(patient.dob!=''? formatDob(patient.dob) :lang.label.nodata)}}</span>


                                        </div>
                                        <div class="col-6 col-lg-5">
                                            <span class="mb-2 d-block">{{lang.label.gender}}:</span>


                                        </div>
                                        <div class="col-6 col-lg-7">
                                            <span class="mb-2 d-block">{{(patient.gender!=''? formatGender(patient.gender) :lang.label.nodata)}}</span>


                                        </div>
                                        <div class="col-6 col-lg-5">
                                            <span class="mb-2 d-block">{{lang.label.bloodGroup}}:</span>


                                        </div>
                                        <div class="col-6 col-lg-7">
                                            <span class="mb-2 d-block">{{(patient.bloodGroup!=''? patient.bloodGroup :lang.label.nodata)}}</span>


                                        </div>
                                        <div class="col-6 col-lg-5">
                                            <span class="mb-0 d-block">{{lang.label.address}}:</span>
                                        </div>
                                        <div class="col-6 col-lg-7">
                                            <span class="mb-0 d-block" v-html="(patient.address!=''? formatAddress(patient.address) :lang.label.nodata)"></span>
                                        </div>
                                    </div>
                                </b-card>
                            </div>
                        </template>
                        <template v-else>
                            <div class="col-12 text-center pt-3">{{lang.label.noDataFound}}</div>
                        </template>
                    </template>      
                </div>
            </b-card>
        </div>
    </div>
</template>

<script>
    import jsondata from "../assets/json/data.json";
    var moment = require('moment'); // require
    export default {
        components: {},
        data() {
            return {
                data: [],
                lang: this.$lang.patient_list,
                loading: true,
                errored: false

            };
        },
        mounted() {
            let data = {
                "pageNo": 1
            };
            this.$store.dispatch('getPatientDetails', data)
                    .then(response => {
                        this.data = response.data;
                    })
                    .catch(error => {
                        this.errored = true;
                    })
                    .finally(() => this.loading = false)
        },
        methods: {
            formatAddress(address){
                return address.replace(/\n/g, '<br/>');
            },
            formatDob(date) {
                return moment(date).format('DD/MM/YYYY');
            },
            formatGender(value) {
                if (value === 1)
                {
                    return this.lang.label.male;
                } else if (value === 2) {
                    return this.lang.label.female;
                } else if (value === 3) {
                    return this.lang.label.other;
                } else {
                    return this.lang.label.nodata;
                }
            }
        }
    };
</script>
